import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BackendService } from './service/backend.service';
import { UserService } from './service/user.service';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  title = 'SatPhoneRecharge';

  constructor(
    private readonly usersService: UserService,
    private readonly backendService: BackendService
  ) {
  }

  ngOnInit(): void {
    this.usersService.whoAmI().subscribe({
      next: (result) => {
        console.log('whoAmI result', result);
        if (result.data?.whoAmI.token) {
          this.backendService.setAuthToken(result.data.whoAmI.token);
          this.usersService.setUserLoggedIn({
            username: result.data.whoAmI.username ?? '',
            token: result.data.whoAmI.token,
            userId: result.data.whoAmI.userId ?? '',
            email: result.data.whoAmI.email ?? '',
            groups: result.data.whoAmI.groups ?? [],
            expiryAt: result.data.whoAmI.expiryAt ?? ''
          })
        }
      },
      error: (error) => {
        console.error('Error checking who am I:', error);
      }
    })
  }
}
